import { useTileContext } from 'widgets/tiles/components/tile/TileContext';
import { buildTilesConfigSlice } from 'widgets/tiles/store/config/configSlice';
import { useDispatch, useSelector } from 'react-redux';
import State from 'store/State';

export function useDispatchRemoveTile(widgetKeyToRemove: string) {
    const { tilesWidgetKey } = useTileContext();
    const dispatch = useDispatch();

    // We are in the tile context but we need to select the config for the tiles widget...
    const configSlice = buildTilesConfigSlice();
    const config = useSelector((state: State) =>
        configSlice.selectors.selectConfigState(state, tilesWidgetKey)
    );

    return () => {
        const nextTiles = config.tiles.filter(
            (t) => t.widgetKey !== widgetKeyToRemove
        );
        const action = configSlice.actions.createUpdateConfigAction(
            tilesWidgetKey,
            {
                tiles: nextTiles,
            }
        );
        dispatch(action);
    };
}
